// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iXilKDQslbsli13_QMh9{padding-left:24px;padding-right:24px}.iXilKDQslbsli13_QMh9.YDFzVdW5woHjJh7VAcUs{width:100%}.fo5cOmnBnooNm7uyagwL{border-top:1px solid var(--border-neutral-default);padding-top:20px;padding-bottom:20px}.M3Cn5sOIQFkWpkezlNFd{border-top:1px solid var(--border-neutral-default);color:var(--content-primary-tertiary);padding-top:16px;padding-bottom:16px;position:relative}.aBsKrzleK_UvOwGimNbc{align-items:center;display:flex}.bh32YEAah58MwxIzpvAb{flex:1;min-width:0}.E4llhEAwkOQ16fn7sDix{justify-content:flex-end;gap:8px;padding-top:16px;padding-bottom:24px;display:flex}.QBeONGXwqbs98LsaRW0a{min-width:122px;padding-left:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `iXilKDQslbsli13_QMh9`,
	"fullWidth": `YDFzVdW5woHjJh7VAcUs`,
	"headerCard": `fo5cOmnBnooNm7uyagwL`,
	"content": `M3Cn5sOIQFkWpkezlNFd`,
	"contentLine": `aBsKrzleK_UvOwGimNbc`,
	"contentFiled": `bh32YEAah58MwxIzpvAb`,
	"actions": `E4llhEAwkOQ16fn7sDix`,
	"inputLabel": `QBeONGXwqbs98LsaRW0a`
};
export default ___CSS_LOADER_EXPORT___;
